import { createRouter, createWebHashHistory } from "vue-router";
import store from '@/store/index';

const routes = [
    {
        path: '/',
        name: 'Main',
        component: () => import('@/views/Main.vue'),
        children: [
            {
                path: '/Home',
                name: 'Home',
                component: () => import('@/views/baseInfo/home')
            },
            {
                path: '/AdminAcadYearTerm',
                name: 'AdminAcadYearTerm',
                component: () => import('@/views/baseInfo/acadYearTerm/adminIndex.vue')
            },
            {
                path: '/School',
                name: 'School',
                component: () => import('@/views/baseInfo/school')
            },
            {
                path: '/Grade',
                name: 'Grade',
                component: () => import('@/views/baseInfo/grade')
            },
            {
                path: '/Class',
                name: 'Class',
                component: () => import("@/views/baseInfo/class")
            },
            {
                path: '/StudentInformation',
                name: 'StudentInformation',
                component: () => import('@/views/studentInformation')
            },
            {
                path: '/AccountManagement',
                name: 'AccountManagement',
                component: () => import('@/views/baseInfo/accountManagement')
            },
            {
                path: '/SystemMenu',
                name: 'SystemMenu',
                component: () => import('@/views/baseInfo/menuItem')
            },
            {
                path: '/Role',
                name: 'Role',
                component: () => import('@/views/baseInfo/role')
            },
            {
                path: '/JointExamAccount',
                name: 'JointExamAccount',
                component: () => import('@/views/baseInfo/jointExamAccount')
            },
            {
                path: '/QuestionBankUser',
                name: 'QuestionBankUser',
                component: () => import('@/views/baseInfo/questionBankAccount')
            },
            {
                path: '/MarkingOfficer',
                name: 'MarkingOfficer',
                component: () => import('@/views/baseInfo/markingOfficer')
            },
            {
                path: '/MarkingTeacher',
                name: 'MarkingTeacher',
                component: () => import('@/views/baseInfo/markingTeacher')
            },
            {
                path: '/Teacher',
                name: 'Teacher',
                component: () => import('@/views/baseInfo/teacher')
            },
            {
                path: '/AiAgent',
                name: 'AiAgent',
                component: () => import('@/views/baseInfo/aiAgent')
            },
            {
                path: '/KnowledgePoint',
                name: 'KnowledgePoint',
                component: () => import('@/views/baseInfo/knowledgePoint')
            },
            {
                path: '/QuestionType',
                name: 'QuestionType',
                component: () => import('@/views/baseInfo/questionType')
            },
            {
                path: '/Log',
                name: 'Log',
                component: () => import('@/views/baseInfo/errorLog')
            },
            {
                path: '/HelpDocumentType',
                name: 'HelpDocumentType',
                component: () => import('@/views/baseInfo/helpDocumentType')
            },
            {
                path: '/HelpDocument',
                name: 'HelpDocument',
                component: () => import('@/views/baseInfo/helpDocument')
            },
            {
                path: '/Error',
                name: 'Error',
                component: () => import('@/views/baseInfo/error')
            }
        ]
    },
    {
        path: '/Paper',
        name: 'Paper',
        component: () => import('@/views/Paper.vue'),
        redirect: '/Exam',
        children: [
            {
                path: '/AcadYearTerm',
                name: 'AcadYearTerm',
                component: () => import('@/views/baseInfo/acadYearTerm')
            },
            {
                path: '/Exam',
                name: 'Exam',
                component: () => import('@/views/exams')
            },
            {
                path: '/Examinee',
                name: 'Examinee',
                component: () => import('@/views/examinee')
            },
            {
                path: '/EditStudentInfo',
                name: 'EditStudentInfo',
                component: () => import('@/views/editStudentInfo')
            },
            {
                path: '/Toolbox',
                name: 'Toolbox',
                component: () => import('@/views/toolbox/index.vue')
            },
            {
                path: '/AddExaminee',
                name: 'AddExaminee',
                component: () => import('@/views/toolbox/addExaminee.vue')
            },
            {
                path: '/SubScoreDetailsAi',
                name: 'SubScoreDetailsAi',
                component: () => import('@/views/examinee/subScoreDetailsAi')
            },
            {
                path: '/ManMachineDifference',
                name: 'ManMachineDifference',
                component: () => import('@/views/examinee/manMachineDifference')
            },
            {
                path: '/ExamReport',
                name: 'ExamReport',
                component: () => import('@/views/examReport/index')
                // component: () => {
                //     // 故意返回一个永远 reject 的 Promise
                //     return new Promise((resolve, reject) => {
                //         setTimeout(() => {
                //             reject(new Error('模拟的 ChunkLoadError: Loading chunk 3587 failed'))
                //         }, 1000)
                //     })
                // }
            },
            {
                path: '/ReportInfoAdmin',
                name: 'ReportInfoAdmin',
                component: () => import('@/views/examReport/reportInfo')
            },
            {
                path: '/AnswerPaper',
                name: 'AnswerPaper',
                component: () => import('@/views/answerPaper/index')
            },

            {
                path: '/Personnel',
                name: 'Personnel',
                component: () => import('@/views/personnel')
            },
            {
                path: '/ExamSetting',
                name: 'ExamSetting',
                component: () => import('@/views/examSetting')
            },
            {
                path: '/ExceptionHandling',
                name: 'ExceptionHandling',
                component: () => import('@/views/exceptionHandling')
            },
            {
                path: '/ScanSheet',
                name: 'ScanSheet',
                component: () => import('@/views/scanSheet')
            },
            {
                path: '/MarkingMonitor',
                name: 'MarkingMonitor',
                component: () => import('@/views/markingMonitor')
            },
            {
                path: '/SamplingReview',
                name: 'SamplingReview',
                component: () => import('@/views/markingMonitor/samplingReview')
            },
            {
                path: '/ScoreManagement',
                name: 'ScoreManagement',
                component: () => import('@/views/scoreManagement')
            },
            {
                path: '/GradeRankingData',
                name: 'GradeRankingData',
                component: () => import('@/views/gradeRankingData')
            },
            {
                path: '/PaperError',
                name: 'PaperError',
                component: () => import('@/views/baseInfo/error')
            },
            {
                path: '/ReviewProblemVolume',
                name: 'ReviewProblemVolume',
                component: () => import('@/views/markingTask/reviewProblemVolume')
            },
            {
                path: '/allPapers',
                name: 'allPapers',
                component: () => import('@/views/allPapers')
            },
            {
                path: '/testPaperComposition',
                name: 'TestPaperComposition',
                component: () => import('@/views/testPaperComposition')
            },
            {
                path: '/downloadTestPaper',
                name: 'DownloadTestPaper',
                component: () => import('@/views/testPaperComposition/downloadTestPaper')
            },
            {
                path: '/testPreview',
                name: 'TestPreview',
                component: () => import('@/views/testPaperComposition/testPreview')
            },
            {
                path: '/myTestPaper',
                name: 'MyTestPaper',
                component: () => import('@/views/myTestPaper')
            },
            {
                path: '/uploadExamPaper',
                name: 'UploadExamPaper',
                component: () => import('@/views/uploadExamPaper')
            },
            {
                path: '/authentication',
                name: 'Authentication',
                component: () => import('@/views/authentication/index')
            },
            {
                path: '/intelligentPaper',
                name: 'IntelligentPaper',
                component: () => import('@/views/intelligentPaper/index')
            },
            // {
            //     path: '/aiReadingProcessing',
            //     name: 'AiReadingProcessing',
            //     component: () => import('@/views/aiReadingProcessing/index')
            // }
            {
                path: '/aiReadingProcessing',
                name: 'AiReadingProcessing',
                component: () => import('@/views/aiReadingProcessing/index')
            },
            {
                path: '/detection',
                name: 'Detection',
                component: () => import('@/views/aiReadingProcessing/detection')
            }
        ]
    },
    {
        path: '/helpCenter',
        name: 'HelpCenter',
        component: () => import('@/views/helpCenter/index')
    },
    {
        path: '/helpCenterDetail',
        name: 'HelpCenterDetail',
        component: () => import('@/views/helpCenter/detail')
    },
    {
        path: '/ExamMarker',
        name: 'ExamMarker',
        component: () => import('@/views/ExamMarker.vue'),
        redirect: '/ReportInfo',
        children: [
            {
                path: '/MarkingTask',
                name: 'MarkingTask',
                component: () => import('@/views/markingTask')
            },
            // {
            //     path: '/ExamReport',
            //     name: 'ExamReport',
            //     component: () => import('@/views/examReport') 
            // },
            {
                path: '/ReportInfo',
                name: 'ReportInfo',
                component: () => import('@/views/examReport/reportInfo')
            },
            {
                path: '/QuestionPieceTask',
                name: 'QuestionPieceTask',
                component: () => import('@/views/markingTask/questionPieceTask')
            },
            {
                path: '/ReviewQuestionPiece',
                name: 'ReviewQuestionPiece',
                component: () => import('@/views/markingTask/reviewQuestionPiece')
            },
            {
                path: '/AgainRead',
                name: 'AgainRead',
                component: () => import('@/views/markingTask/againRead')
            },
            {
                path: '/TReviewProblemVolume',
                name: 'TReviewProblemVolume',
                component: () => import('@/views/markingTask/reviewProblemVolume')
            },
            {
                path: '/ReviewQuestionAgain',
                name: 'ReviewQuestionAgain',
                component: () => import('@/views/markingTask/reviewquestionPieceAgain')
            },
            {
                path: '/ReEvaluation',
                name: 'ReEvaluation',
                component: () => import('@/views/markingTask/evaluation')
            },
            {
                path: '/ExamMarkerError',
                name: 'ExamMarkerError',
                component: () => import('@/views/baseInfo/error')
            },
            {
                path: '/AchievementAnalysis',
                name: 'AchievementAnalysis',
                component: () => import('@/views/achievementAnalysis')
            },
            {
                path: '/ScoreAnalysis',
                name: 'ScoreAnalysis',
                component: () => import('@/views/achievementAnalysis/scoreAnalysis')
            },
            {
                path: '/ArbitrationTask',
                name: 'ArbitrationTask',
                component: () => import('@/views/arbitrationTask')
            },
            {
                path: '/AiArbitrationTask',
                name: 'AiArbitrationTask',
                component: () => import('@/views/aiArbitrationTask')
            },
            {
                path: '/BlockArbitrationTask',
                name: 'BlockArbitrationTask',
                component: () => import('@/views/arbitrationTask/questionPieceTask.vue')
            },
            {
                path: '/QuestionArbitration',
                name: 'QuestionArbitration',
                component: () => import('@/views/arbitrationTask/questionArbitration.vue')
            },
            {
                path: '/AiArbitration',
                name: 'AiArbitration',
                component: () => import('@/views/aiArbitrationTask/aiArbitration.vue')
            },
            {
                path: '/ArbitrationMarkerError',
                name: 'ArbitrationMarkerError',
                component: () => import('@/views/baseInfo/error')
            },
            {
                path: '/TeacherMarkingMonitor',
                name: 'TeacherMarkingMonitor',
                component: () => import('@/views/markingMonitor')
            },
            {
                path: '/TeacherSamReview',
                name: 'TeacherSamReview',
                component: () => import('@/views/markingMonitor/samplingReview')
            },
        ]
    },
    {
        path: '/ArbitrationMarker',
        name: 'ArbitrationMarker',
        component: () => import('@/views/ArbitrationMarker.vue'),
        redirect: '/ArbitrationTask',
        children: [
            {
                path: '/ArbitrationTask',
                name: 'ArbitrationTask',
                component: () => import('@/views/arbitrationTask')
            },
            {
                path: '/AiArbitrationTask',
                name: 'AiArbitrationTask',
                component: () => import('@/views/aiArbitrationTask')
            },
            // {
            //     path: '/BlockArbitrationTask',
            //     name: 'BlockArbitrationTask',
            //     component: () => import('@/views/arbitrationTask/questionPieceTask.vue')
            // },
            // {
            //     path: '/QuestionArbitration',
            //     name: 'QuestionArbitration',
            //     component: () => import('@/views/arbitrationTask/questionArbitration.vue')
            // },
            {
                path: '/AiArbitration',
                name: 'AiArbitration',
                component: () => import('@/views/aiArbitrationTask/aiArbitration.vue')
            },
            {
                path: '/ArbitrationMarkerError',
                name: 'ArbitrationMarkerError',
                component: () => import('@/views/baseInfo/error')
            },
        ]
    },

    {
        path: '/addPaper',
        name: 'addPaper',
        component: () => import('@/views/answerPaper/addPaper')
    },
    {
        path: '/preview',
        name: 'preview',
        component: () => import('@/views/answerPaper/preview')
    },
    {
        path: '/previewSelf',
        name: 'previewSelf',
        component: () => import('@/views/answerPaper/previewSelf')
    },
    {
        path: '/CreateTemp',
        name: 'CreateTemp',
        component: () => import('@/views/answerSheet/createTemp.vue')
    },
    {
        path: '/TempPicture',
        name: 'TempPicture',
        component: () => import('@/views/answerSheet/tempPicture.vue')
    },
    {
        path: '/AnswerSheet',
        name: 'AnswerSheet',
        component: () => import('@/views/answerSheet/index.vue')
    },
    {
        path: '/AbnormalProcessing',
        name: 'AbnormalProcessing',
        component: () => import('@/views/abnormalProcessing')
    },
    {
        path: '/EditExceptionVolume',
        name: 'EditExceptionVolume',
        component: () => import('@/views/editExceptionVolume')
    },
    {
        path: '/Login',
        name: 'Login',
        component: () => import('@/views/baseInfo/login')
    },
    {
        path: '/QuestionBlock',
        name: 'QuestionBlock',
        component: () => import('@/views/questionBlock/index.vue'),
        redirect: () => {
            store.commit('getUserInfo')
            const roleType = store.state.user.userInfo?.roleType
            if (roleType === 18) return { name: 'QBStage' }
            return { name: 'QuestionBankWorkbench' }
        },
        children: [
            {
                path: '/QuestionBankWorkbench',
                name: 'QuestionBankWorkbench',
                component: () => import('@/views/questionBlock/questionData/workbench/index.vue')
            },
            {
                path: '/QuestionBankInput',
                name: 'QuestionBankInput',
                component: () => import('@/views/questionBlock/questionData/input/index.vue')
            },
            {
                path: '/QuestionBankMyBank',
                name: 'QuestionBankMyBank',
                component: () => import('@/views/questionBlock/questionData/myBank/index.vue')
            },
            {
                path: '/QuestionBankManage',
                name: 'QuestionBankManage',
                component: () => import('@/views/questionBlock/questionData/manage/index.vue')
            },
            {
                path: '/QuestionBankPending',
                name: 'QuestionBankPending',
                component: () => import('@/views/questionBlock/questionData/pending/index.vue')
            },
            {
                path: '/QuestionBankStored',
                name: 'QuestionBankStored',
                component: () => import('@/views/questionBlock/questionData/stored/index.vue')
            },
            {
                path: '/QuestionBankTag',
                name: 'QuestionBankTag',
                component: () => import('@/views/questionBlock/questionData/tag/index.vue')
            },
            {
                path: '/QuestionBankXkw',
                name: 'QuestionBankXkw',
                component: () => import('@/views/questionBlock/questionData/xkw/index.vue')
            },
            {
                path: '/QBUserManage',
                name: 'QBUserManage',
                component: () => import('@/views/baseInfo/questionBankAccount')
            },
            {
                path: '/QBStage',
                name: 'QBStage',
                component: () => import('@/views/questionBlock/baseData/stage/index.vue')
            },
            {
                path: '/QBGrade',
                name: 'QBGrade',
                component: () => import('@/views/questionBlock/baseData/grade/index.vue')
            },
            {
                path: '/QBSubject',
                name: 'QBSubject',
                component: () => import('@/views/questionBlock/baseData/subject/index.vue')
            },
            {
                path: '/QBCourse',
                name: 'QBCourse',
                component: () => import('@/views/questionBlock/baseData/course/index.vue')
            },
            {
                path: '/QBTextbook',
                name: 'QBTextbook',
                component: () => import('@/views/questionBlock/baseData/textbook/index.vue')
            },
            {
                path: '/QBTextbookVersion',
                name: 'QBTextbookVersion',
                component: () => import('@/views/questionBlock/baseData/textbookVersion/index.vue')
            },
            {
                path: '/QBKPoint',
                name: 'QBKPoint',
                component: () => import('@/views/questionBlock/baseData/kpoint/index.vue')
            },
            {
                path: '/QBCatalog',
                name: 'QBCatalog',
                component: () => import('@/views/questionBlock/baseData/catalog/index.vue')
            },
            {
                path: '/QBQuestionType',
                name: 'QBQuestionType',
                component: () => import('@/views/questionBlock/baseData/questionType/index.vue')
            },
            {
                path: '/QBDifficulty',
                name: 'QBDifficulty',
                component: () => import('@/views/questionBlock/baseData/difficulty/index.vue')
            },
        ]
    },
]

const router = createRouter({
    history: createWebHashHistory(),
    routes
})

router.beforeEach((to, from, next) => {
    store.commit('getToken')
    const token = store.state.user.token
    if (token) {
        store.commit("getUserMenu");
        var menuList = store.state.user.userMenu;
        var usercomponents = getUserComponents(menuList);
        if (usercomponents.includes(to.name) || to.name.indexOf("Error") > -1 || to.name.indexOf('ReportInfo') >= 0
            || to.name.indexOf('ReportInfoAdmin') >= 0
            || to.name === 'ExamReport'
            || to.name.indexOf('AnswerPaper') >= 0
            || to.name.indexOf('addPaper') >= 0
            || to.name.indexOf('preview') >= 0
            || to.name.indexOf('previewSelf') >= 0
            || to.name === 'allPapers'
            || to.name === 'Toolbox'
            || to.name === 'AddExaminee'
            || to.name === 'Authentication'
            || to.name === 'IntelligentPaper'
            || to.name === 'HelpCenter'
            || to.name === 'HelpCenterDetail'
            || to.name === 'Examinee') next();
        else {
            store.commit("clearToken");
            next({ name: 'Login' });
        }
    }
    else {
        if (to.name !== 'Login') next({ name: 'Login' });
        else next();
    }
})

const getUserComponents = function (menuList) {
    var components = [];
    store.commit('getUserInfo');
    var userInfo = store.state.user.userInfo;
    if (userInfo && userInfo.roleType == 1) {
        components.push("Main")
        components.push("Home")
    }
    if (userInfo && (userInfo.roleType == 12 || userInfo.roleType == 2)) components.push("Paper");
    else if (userInfo && userInfo.roleType == 13 && !userInfo.isArbitrationTeacher)
        components.push("ExamMarker");
    else if (userInfo && userInfo.isArbitrationTeacher) components.push("ArbitrationTask");
    // 题库角色：18 超管 / 19 管理员 / 20 录入
    if (userInfo && userInfo.roleType >= 18 && userInfo.roleType <= 20) {
        components.push(
            "QuestionBlock",
            "QuestionBank",
            "QuestionBankWorkbench",
            "QuestionBankInput",
            "QuestionBankMyBank",
            "QuestionBankManage",
            "QuestionBankPending",
            "QuestionBankStored",
            "QuestionBankTag",
            "QuestionBankXkw",
            "QBUserManage",
            "QBStage",
            "QBGrade",
            "QBSubject",
            "QBCourse",
            "QBTextbook",
            "QBTextbookVersion",
            "QBKPoint",
            "QBCatalog",
            "QBQuestionType",
            "QBDifficulty"
        );
    }
    if (menuList && menuList.length > 0) {
        menuList.forEach(item => {
            components.push(item.componentName);
            if (item.children && item.children.length > 0) {
                item.children.forEach(child => {
                    components.push(child.componentName)
                })
            }
        });
    }
    return components;
}

let hasReloaded = false

// 监听路由错误
router.onError((error) => {
    const errorMessages = [
        error.message,
        error.toString(),
        error?.reason?.message
    ].filter(Boolean)

    const isChunkError = errorMessages.some(msg =>
        /Loading chunk \d+ failed/i.test(msg) ||
        /Failed to fetch dynamically imported module/i.test(msg) ||
        /Failed to load module script/i.test(msg)
    )

    if (isChunkError && !hasReloaded) {
        hasReloaded = true
        console.warn('[Router Error] 路由懒加载失败，刷新页面', error)
        window.location.reload()
        // 可选：给用户一个提示
        // 使用 tryRefresh 函数
        //tryRefresh()
    }
})

// // 刷新函数（带防循环）
// function tryRefresh() {
//     const refreshKey = '__VUE_CHUNK_REFRESH__'
//     if (!sessionStorage.getItem(refreshKey)) {
//         sessionStorage.setItem(refreshKey, 'true')
//         window.location.reload()
//     } else {
//         // 刷新后还是失败，清空标志，避免死循环
//         sessionStorage.removeItem(refreshKey)
//         console.error('[Router Error] 刷新后仍然失败，请检查网络或清理缓存')

//     }
// }

export default router;